<template>
  <div class="col-12 px-0">
    <NewsletterType
      :draft="draft"
      :newsletter-types="newsletterTypes"
      @clearedDraft="onClearedDraft"
    />
  </div>
</template>

<script>
import NewsletterType from '../Components/NewsletterType'

export default {
  name: 'TellimerTodayChooseTypeStep',

  components: {
    NewsletterType,
  },

  props: {
    draft: {
      type: Object,
      required: true,
    },
    newsletterTypes: {
      type: Array,
      required: true,
    },
  },

  metaInfo () {
    return {
      title: this.draft && this.draft.subject ? this.draft.subject : 'Create Newsletter',
    }
  },

  data () {
    return {
      error: null,
    }
  },

  async created() {
    const {template} = this.$route.query

    if (template === 'tellimer-today-latest-layout') {
      this.$emit('force-next')
    }
  },

  methods: {
    onClearedDraft (newDraft) {
      this.$emit('clearedDraft', newDraft)
    },
  },
}
</script>

